import React from "react"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import classes from "./LsmFooter.module.scss"

const LsmFooter = props => {
  const {
    onDone,
    selectedFoods,
    setOpenModal,
    setShowSelectedFoods
  } = props

  const [t] = useTranslation()

  const handleDone = () => {
    onDone({ ...selectedFoods })

    setOpenModal(false)
  }

  const noSelectedFoods =
    Object.keys(selectedFoods).length === 0

  return (
    <div className={classes["footer"]}>
      <Button
        color="info"
        className={classes["button"]}
        disabled={noSelectedFoods}
        onClick={() => setShowSelectedFoods(true)}
      >
        {t("کالا_های_انتخاب_شده")}
      </Button>
      <div>
        <Button
          color="danger"
          className={classes["button"]}
          onClick={() => setOpenModal(false)}
        >
          {t("لغو")}
        </Button>
        <Button
          onClick={handleDone}
          color="success"
        >
          {t("تایید")}
        </Button>
      </div>
    </div>
  )
}

export default LsmFooter